/* eslint-disable @typescript-eslint/ban-ts-comment */
import type { IPRChartContext, IPRChartData } from "./d";
import type { ScenarioCalculations } from "@/composables/scenarioCalculations/calculationTypes";
import type { WellProperties } from "@/composables/forms/formTypes";
import { getCompositeDataset } from "./getCompositeDataset";
import type { ConvertableUnit } from "@/libs/units";
import { getStraightDataset } from "./getStraightDataset";
import { getVogelDataset } from "./getVogelDataset";
import { getVogelModifiedDataSet } from "./getVogelModifiedDataSet";

const buildIPRChartContext = (
  calcs: ScenarioCalculations,
  targetPressureUnit: ConvertableUnit,
  targetLiquidFlowUnit: ConvertableUnit,
  wellProperties?: WellProperties
): IPRChartContext => {
  const destructuredScenario = calcs.destructuredScenario;
  const context: IPRChartContext = {
    wellProperties:
      // @ts-ignore
      wellProperties ?? destructuredScenario.wellProperties?.value,
    wellTestFlowRates: calcs.wellTestFlowRates.value,
    fluidPropertiesAtReservoir:
      calcs.fluidProperties.fluidPropertiesAtReservoir.value,
    targetLiquidFlowUnit,
    targetPressureUnit,
    desiredLiquidRateSTBD: calcs.desiredLiquidRateSTDB.value,
    iterations: 250
  };

  return context;
};

export const useIPRChartData = (
  scenarioCalculations: ScenarioCalculations,
  targetPressureUnit: ConvertableUnit,
  targetLiquidFlowUnit: ConvertableUnit,
  wellProperties?: WellProperties
): IPRChartData | undefined => {
  const context = buildIPRChartContext(
    scenarioCalculations,
    targetPressureUnit,
    targetLiquidFlowUnit,
    wellProperties
  );

  if (!context) {
    return undefined;
  } else {
    const straightDataSet = getStraightDataset(context);
    const compositeDataSet = getCompositeDataset(context);
    const vogelDataSet = getVogelDataset(context);
    const vogelModifiedDataSet = getVogelModifiedDataSet(context);
    return {
      context,
      straightDataSet,
      compositeDataSet,
      vogelDataSet,
      vogelModifiedDataSet
    };
  }
};
